import React, { Component } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGoogleDisconnectOAuthDTO from "../../../../models/DTO/IGoogleDisconnectOAuthDTO";
import IGoogleInitDriveDTO from "../../../../models/DTO/IGoogleInitDriveDTO";
import IGoogleStartOAuthDTO from "../../../../models/DTO/IGoogleStartOAuthDTO";
import ILoadDashboardDTO from "../../../../models/DTO/ILoadDashboardDTO";
import IOnGoogleDisconnectOAuthDTO from "../../../../models/DTO/IOnGoogleDisconnectOAuthDTO";
import IOnGoogleInitDriveDTO from "../../../../models/DTO/IOnGoogleInitDriveDTO";
import IOnGoogleStartOAuthDTO from "../../../../models/DTO/IOnGoogleStartOAuthDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import googleConnectLogo from "../../../../assets/images/google/btn_google_signin_dark_normal_web@2x.png";
import googleLogo from "../../../../assets/images/google/Google_2015_logo.svg";
import "./GoogleConnect.scss";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

type State = {};

class GoogleConnect extends Component<Props, State> {
    componentDidMount() {
        this.props.socket.on(EndpointsEnum.GoogleOnStartOAuth, this.onStartOAuth);
        this.props.socket.on(EndpointsEnum.GoogleOnDisconnectOAuth, this.onDisconnect);
        this.props.socket.on(EndpointsEnum.GoogleOnInitDrive, this.onInitDrive);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.GoogleOnStartOAuth, this.onStartOAuth);
        this.props.socket.removeListener(EndpointsEnum.GoogleOnDisconnectOAuth, this.onDisconnect);
        this.props.socket.removeListener(EndpointsEnum.GoogleOnInitDrive, this.onInitDrive);
    }

    onStartOAuth = (data: IOnGoogleStartOAuthDTO) => {
        // @ts-expect-error
        window.location = data.url;
    };

    startGoogleOAuth = () => {
        const payload: IGoogleStartOAuthDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.GoogleStartOAuth, payload);
    };

    disconnect = () => {
        const payload: IGoogleDisconnectOAuthDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.GoogleDisconnectOAuth, payload);
    };

    onDisconnect = (data: IOnGoogleDisconnectOAuthDTO) => {
        const payload: ILoadDashboardDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
        };

        this.props.socket.emit(EndpointsEnum.DashboardLoadDashboard, payload);
    };

    initDrive = () => {
        const payload: IGoogleInitDriveDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.GoogleInitDrive, payload);
    };

    onInitDrive = (data: IOnGoogleInitDriveDTO) => {};

    getDisconnect = () => {
        return (
            <div>
                <div className={"text-center"}>
                    <div>
                        <OwLabel className={"text-success"} leftIconClass={"far fa-check"} title={"connected_to_google"} />
                    </div>
                    <div>
                        <OwButton
                            minWidth={225}
                            className={"btn-danger"}
                            fn={this.disconnect}
                            leftIconClass={"fas fa-unlink"}
                            title={"disconnect_google"}
                        />
                    </div>
                    <div className={"mt-4"}>
                        <OwButton fn={this.initDrive} title={"initialize_drive"} />
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const hasGoogle = !!this.props.supplierModel.Supplier_Integration.has_google;

        return (
            <div className="GoogleConnect">
                <OwAccordion
                    hideChevron={!hasGoogle}
                    leftImage={googleLogo}
                    leftImageHeight={30}
                    titleClick={hasGoogle}
                    rightElem={
                        <div className={"ms-auto"}>
                            <div tabIndex={0} className={"pointer"} onClick={this.startGoogleOAuth}>
                                <img src={googleConnectLogo} style={{ height: "2.5rem" }} />
                            </div>
                        </div>
                    }>
                    <div className={"d-flex flex-column align-items-center"}>
                        <div className={""}>{hasGoogle ? this.getDisconnect() : null}</div>
                    </div>
                </OwAccordion>
            </div>
        );
    }
}

export default GoogleConnect;
